import { render, staticRenderFns } from "./ModernDragDropInput.vue?vue&type=template&id=0a7a75fe&scoped=true&"
import script from "./ModernDragDropInput.vue?vue&type=script&lang=js&"
export * from "./ModernDragDropInput.vue?vue&type=script&lang=js&"
import style0 from "./ModernDragDropInput.vue?vue&type=style&index=0&id=0a7a75fe&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7a75fe",
  null
  
)

export default component.exports